import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Recycle, RefreshCcw } from "lucide-react";

export default function ReloadPage() {
  const handleReload = () => {
    window.location.reload(); // reload full page
  };

  return (
    <Button onClick={handleReload} variant="secondary" size="sm" className='border bg-stone-200 gap-2 hover:shadow-md hover:bg-stone-300'>
      <RefreshCcw className="h-4 w-4" /> Reset
    </Button>
  );
}